import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MapNavigationService {
  private readonly goToRealtimeMapSubject = new Subject<void>();
  readonly goToRealtimeMap$ = this.goToRealtimeMapSubject.asObservable();

  private readonly toolbarHiddenSubject = new BehaviorSubject<boolean>(false);
  readonly toolbarHidden$ = this.toolbarHiddenSubject.asObservable();

  requestRealtimeMap() {
    this.goToRealtimeMapSubject.next();
  }

  setToolbarHidden(hidden: boolean) {
    this.toolbarHiddenSubject.next(hidden);
  }
}
